import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { orderBy } from 'lodash';

const styles = {
  table: {
    width: '60%',
    borderCollapse: 'collapse',
    borderSpacing: 0
  },
  emptyRow: {
    textAlign: 'center'
  }
};


function RunsUpcomingTable(props) {
  const upcomingRuns = orderBy(
    props.runs.filter(run => run.planned_start), 'planned_start', 'desc'
  );
  return (
    <table className="queueT" style={styles.table}>
      <tbody>
        <tr>
          <th colSpan={4}>
            Upcoming <span style={{ color: 'red' }}>{props.platformName}</span> Runs
          </th>
        </tr>
        <tr>
          <th>Run</th>
          <th>Type</th>
          <th>#</th>
          <th>Planned Dates</th>
        </tr>
        {upcomingRuns.length ? upcomingRuns.map(run => (
          <tr key={run.run_id}>
            <td>{run.run_id}</td>
            <td>{run.run_type}</td>
            <td>{run.n_samples}</td>
            <td>
              {moment(run.planned_start).format('MMM. D')}
              &nbsp;&ndash;&nbsp;
              {moment(run.planned_end).format('MMM. D')}
            </td>
          </tr>
        )) :
          <tr>
            <td colSpan={4} style={styles.emptyRow}>
              No upcoming {props.platformName} runs.
            </td>
          </tr>
        }
      </tbody>
    </table>
  );
}

RunsUpcomingTable.propTypes = {
  platformName: PropTypes.string.isRequired,
  runs: PropTypes.array.isRequired
};

export default RunsUpcomingTable;
